import { NoticeContainer, NoticeItem, NoticeList } from './styles'

export function Notice() {
  const notices = [
    '1인 1회 신청 가능하며, 재고 소진 시 조기 마감될 수 있어요',
    '단순 변심으로 인한 교환 및 환불이 불가해요',
  ]

  return (
    <NoticeContainer>
      <NoticeList>
        {notices.map((text) => (
          <NoticeItem key={text}>{text}</NoticeItem>
        ))}
      </NoticeList>
    </NoticeContainer>
  )
}
